import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUp, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { BrandLogo } from "@/components/BrandLogo";

const SLATE = [{ to: "/", label: "Players Projections" }, { to: "/today", label: "Game Center" }];

function Newsletter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.already ? "You are already subscribed." : "Subscribed — thanks!");
      setEmail("");
    } catch (err) { toast.error(errorText(err)); }
    setBusy(false);
  };
  return (
    <form className="nbc-news" onSubmit={submit} data-testid="newsletter-form">
      <h3>STAY UPDATED</h3>
      <p>Get the latest NBA news, analysis and insights.</p>
      <div>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" aria-label="Email address" data-testid="newsletter-email" />
        <button type="submit" disabled={busy} data-testid="newsletter-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Subscribe"}</button>
      </div>
    </form>
  );
}

const Group = ({ title, id, children }) => (
  <section className="nbc-foot-group" data-testid={`footer-group-${id}`}><h3>{title}</h3>{children}</section>
);

export function SiteFooter({ links }) {
  const nba = [...SLATE, ...links.filter((l) => ["/teams", "/standings"].includes(l.to))];
  const tools = links.filter((l) => ["/accuracy", "/upload", "/rotation"].includes(l.to));
  const account = links.filter((l) => ["/account", "/settings"].includes(l.to));
  const item = (l) => <Link key={l.to} to={l.to} data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}>{l.label}</Link>;
  return (
    <footer className="nbc-footer" data-testid="site-footer">
      <div className="nbc-foot-inner">
        <section className="nbc-foot-brand">
          <BrandLogo size="lg" tagline />
          <p>Your complete source for NBA data, projections, analysis, teams, standings and the latest results.</p>
        </section>
        <Group title="NBA" id="nba">{nba.map(item)}</Group>
        <Group title="EUROPE" id="europe">
          <Link to="/europe/E" data-testid="footer-euroleague">EuroLeague</Link>
          <Link to="/europe/U" data-testid="footer-eurocup">EuroCup</Link>
        </Group>
        {tools.length > 0 && <Group title="TOOLS" id="tools">{tools.map(item)}</Group>}
        <Group title="ACCOUNT" id="account">{account.map(item)}</Group>
        <Newsletter />
      </div>
      <div className="nbc-foot-bottom">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} NBACUBE. All rights reserved.</span>
        <span className="nbc-powered" data-testid="footer-powered">Powered by <b>Arenaline</b></span>
        <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} aria-label="Back to top" data-testid="back-to-top"><ArrowUp size={18} /></button>
      </div>
    </footer>
  );
}
